import { cable, unsubscribe, subscribe } from '@/api'
import { AppHolder } from '@/utils/app-holder'
import humps from 'humps'

export default {
  subscribe () {
    if (this.numberOfDisconnections === undefined) {
      this.numberOfDisconnections = 0

      this.setInterval = setInterval(() => {
        this.numberOfDisconnections = 0

        if (this.numberOfDisconnections === 3) {
          clearInterval(this.setInterval)
        }
      }, 1 * 60000)
    } else {
      this.numberOfDisconnections += 1;
    }

    if (this.numberOfDisconnections > 3) {
      clearInterval(this.setInterval)
      return
    }

    if (!this._subscriptions) {
      cable.getSubscriptions().then(subscriptions => {
        this._subscriptions = subscriptions

        if (!this._isExistSubscription('NotificationsChannel')) {
          subscriptions.create({
            channel: 'NotificationsChannel'
          }, {
            disconnected() {
              unsubscribe()
              subscribe()
            },
            received (data) {
              const dataCamelizeKeys = humps.camelizeKeys(data)
              const { resultId } = dataCamelizeKeys

              if (resultId) {
                AppHolder.store.dispatch('asyncResults/fetchAsyncResults', resultId)
              } else {
                AppHolder.store.dispatch('notifications/add', humps.camelizeKeys(data))
              }
            }
          })
        }
      })
    }
  },

  unsubscribe () {
    const { _subscriptions } = this
    if (_subscriptions) {
      for (const sub of _subscriptions.subscriptions) {
        sub.unsubscribe()
      }
      this._subscriptions = null
    }
  },

  _isExistSubscription (channel) {
    const { _subscriptions } = this
    return !!_subscriptions && !!_subscriptions.subscriptions.find(sub => sub.identifier === JSON.stringify({ channel }))
  }
}
